
import { Base } from '../base-component';

import { AnalyticsService } from '../../services/analytics.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import './form-item-cmb-eligibility-business.component.scss';

import * as $ from 'jquery';

export class FormItemCmbEligibilityBusiness extends Base {

	// form
	form: HTMLFormElement;

	// buttons
	buttonSubmit: Element[];

	// select
	selectTitle: any;
	selectCountries: any;

	// hidden
	hidLeadId: any;
	hidProduct: any;
	hidCallMeBackModalId: any;
	hidActivitiesTakePlace: any;
	

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.selectTitle = this.element.querySelector('.js-title');
		this.selectCountries = this.form.querySelector('select[name=companyCountriesOperating]');
		this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.hidLeadId = this.form.querySelector('input[name=leadId]');
		this.hidProduct = this.form.querySelector('input[name=product]');
	}

	bindEvents() {

		this.buttonSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select, textarea');
			const validation = this.validationService.validate(formFields);
			if (validation.valid) {
				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

		$(document).on('click', '.js-apply-now-modal-open', (event) => {
			let element = event.target;
			let type = $(element).attr('data-productname');
			let leadid = $(element).attr('data-leadid');
			let modalId = $(element).attr('data-modal');
			if(type){
				this.hidProduct.value = type;
			}
			if(leadid){
				this.hidLeadId.value = leadid;
			}
			if(modalId){
				this.hidCallMeBackModalId = modalId;
			}
		});

		if(this.selectCountries) {
			
			this.selectCountries.addEventListener('change', (event) => {
				let values = [].slice.call(event.target.selectedOptions).map(a => a.value);
				let result = values.join(', ');
				this.hidActivitiesTakePlace = result;
			});

		}

	}

	addMoreTitle(element) {
		if(element){
			if(element.value == 'Other'){

				let parentParent = element.closest('.form__fields--container');
				let parent = element.closest('.form__group');

				let newContainer = document.createElement('div');
				newContainer.classList.add('form__group');
				newContainer.classList.add('js-other-title-container');

				let newLabel = document.createElement('label');
				newLabel.classList.add('form__label');
				newLabel.innerHTML = 'Other Title';
				newContainer.appendChild(newLabel);

				let newInput = document.createElement('input');
				newInput.classList.add('js-other-title');
				newInput.classList.add('form__input');
				newInput.classList.add('form__input--required');
				newInput.setAttribute('placeholder', 'Enter your title');
				newInput.setAttribute('maxlength', '4');
				newInput.setAttribute('name', 'manager-name');
				newContainer.appendChild(newInput);

				parentParent.insertBefore(newContainer, parent.nextSibling);

			}else{
				let parentParent = element.closest('.form__fields--container');
				let oldInput = this.element.querySelector('.js-other-title-container');
				parentParent.removeChild(oldInput);
			}
		}
	}	

	resetForm() {
		if (this.form) {
			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const productType: any = this.form.querySelector('input[name=product]');
		const leadID: any = this.form.querySelector('input[name=leadId]');
		const companyName: any = this.form.querySelector('input[name=companyName]');
		const companyContactName: any = form.querySelector('input[name=companyContactName]');
		const dialCode: any = form.querySelector('select[name=dialCode]');
		const telNo: any = form.querySelector('input[name=telNo]');
		const emailAddress: any = form.querySelector('input[name=emailAddress]');
		const websiteAddress: any = form.querySelector('input[name=websiteAddress]');
		const companyPrimaryActivities: any = form.querySelector('select[name=companyPrimaryActivities]');
		const companyCountryBased: any = form.querySelector('select[name=companyCountryBased]');
		const companyCountriesOperating: any = form.querySelector('select[name=companyCountriesOperating]');
		const pageUrl: any = window.location.href;

		let postData = '';

		postData += 'operation=submit&';
		postData += 'category=business&';
		if (productType) {
			postData += 'productName=' + productType.value + '&';
		}
		if (leadID) {
			postData += 'leadID=' + leadID.value + '&';
		}
		if (this.hidCallMeBackModalId) {
			postData += 'callmebackFormId=' + this.hidCallMeBackModalId+ '&';
		}
		if (companyName) {
			postData += 'companyName=' + companyName.value + '&';
		}
		if (companyContactName) {
			postData += 'companyContactName=' + companyContactName.value + '&';
		}
		if (dialCode) {
			postData += 'dialCode=' + dialCode.value + '&';
		}
		if (telNo) {
			postData += 'telNo=' + telNo.value + '&';
		}
		if (emailAddress) {
			postData += 'emailAddress=' + emailAddress.value + '&';
		}
		if (websiteAddress) {
			postData += 'websiteAddress=' + websiteAddress.value + '&';
		}
		if (companyPrimaryActivities) {
			postData += 'companyPrimaryActivities=' + companyPrimaryActivities.value + '&';
		}
		if (companyCountryBased) {
			postData += 'companyCountryBased=' + companyCountryBased.value + '&';
		}
		if (this.hidActivitiesTakePlace) {
			postData += 'companyCountriesOperating=' + this.hidActivitiesTakePlace + '&';
		}
		if (pageUrl) {
			postData += 'pageUrl=' + pageUrl + '&';
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitWINLead.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {
			// service ok
			loader.classList.remove('active');
			loader.classList.remove('active');
			thankyou.classList.add('active');
			analyticsService.dtmFormComplete('complete', '');

		}).catch(function (response) {
			// service failed
			loader.classList.remove('active');
			thankyou.classList.add('active');
			analyticsService.dtmFormComplete('complete', '');

		});

	}

}



// WEBPACK FOOTER //
// ./components/form-item-cmb-eligibility-business/form-item-cmb-eligibility-business.component.ts